import { render, staticRenderFns } from "./Prodotto.vue?vue&type=template&id=359e3e20&scoped=true&"
import script from "./Prodotto.vue?vue&type=script&lang=js&"
export * from "./Prodotto.vue?vue&type=script&lang=js&"
import style0 from "./Prodotto.vue?vue&type=style&index=0&id=359e3e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e3e20",
  null
  
)

export default component.exports